import styled from "styled-components";
export const Styles = styled.div`
  .swiper {
    height: 580px;
  }
  @media (max-width: 1400px) {
    .swiper {
      height: 500px;
    }
  }
  @media (max-width: 1200px) {
    .swiper {
      height: 430px;
    }
  }
  @media (max-width: 992px) {
    .swiper {
      height: 120%;
      width: 100%;
      padding-block: 10px 20px;
    }
  }
`;
